import FfactSAP from "../../../views/administrador/Logistica/FfactSAP";




const routes_logistica = [
  {
    path: "/FfactSAP",
    name: "Ingresar Factura FFACSA",
    icon: "",
    component: FfactSAP,
    doNotShow: true,
  },
 
];

export default routes_logistica;
